import React, { useState } from 'react';
import { 
  Plus, 
  Search, 
  MessageSquare, 
  Users, 
  UserPlus,
  MoreVertical
} from 'lucide-react';

const Inbox = () => {
  const [isNewChatOpen, setIsNewChatOpen] = useState(false);

  // Mock data for stories and chats
  const stories = [
    { id: 'add', type: 'add' },
    { id: 1, name: 'Terry', avatar: '/placeholder/32/32' },
    { id: 2, name: 'Craig', avatar: '/placeholder/32/32' },
    { id: 3, name: 'Roger', avatar: '/placeholder/32/32' },
    { id: 4, name: 'Nolan', avatar: '/placeholder/32/32' },
  ];

  const chats = [
    {
      id: 1,
      name: 'Angel Curtis',
      message: 'Please help me find a good monitor for t...',
      time: '02:11',
      unread: 2,
      avatar: '/placeholder/48/48'
    },
    {
      id: 2,
      name: 'Zaire Dorwart',
      message: 'Gacor pisan kang',
      time: '02:11',
      avatar: '/placeholder/48/48'
    },
    {
      id: 3,
      name: 'Kelas Malam',
      message: 'Bima: No one can come today?',
      time: '02:11',
      unread: 2,
      avatar: '/placeholder/48/48'
    },
    {
      id: 4,
      name: 'Jocelyn Gouse',
      message: "You're now an admin",
      time: '02:11',
      avatar: '/placeholder/48/48'
    },
    {
      id: 5,
      name: 'Jaylon Dias',
      message: 'Buy back 10k gallons, top up credit, b...',
      time: '02:11',
      avatar: '/placeholder/48/48'
    }
  ];

  return (
    <div className="min-h-screen bg-white relative">
      {/* Header */}
      <div className="sticky top-0 z-40 bg-white">
        <div className="flex items-center justify-between p-4">
          <h1 className="text-2xl font-semibold">Mengobrol</h1>
          <button className="p-2 hover:bg-gray-100 rounded-full">
            <Search className="w-6 h-6" />
          </button>
        </div>

        {/* Stories */}
        <div className="px-4 pb-4">
          <div className="flex space-x-4 overflow-x-auto scrollbar-hide">
            {stories.map((story) => (
              <div key={story.id} className="flex flex-col items-center flex-shrink-0">
                <div className={`w-16 h-16 rounded-full ${
                  story.type === 'add' 
                    ? 'border-2 border-gray-300 border-dashed flex items-center justify-center'
                    : 'border-2 border-orange-500 p-0.5'
                }`}>
                  {story.type === 'add' ? (
                    <Plus className="w-6 h-6 text-gray-400" />
                  ) : (
                    <img
                      src={story.avatar}
                      alt={story.name}
                      className="w-full h-full rounded-full object-cover"
                    />
                  )}
                </div>
                <span className="mt-1 text-xs text-center">
                  {story.type === 'add' ? 'Add story' : story.name}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Chats Header */}
        <div className="px-4 py-2 border-b">
          <div className="flex justify-between items-center">
            <h2 className="text-lg font-medium">Chats</h2>
            <button className="p-1 hover:bg-gray-100 rounded-full">
              <MoreVertical className="w-5 h-5 text-gray-500" />
            </button>
          </div>
        </div>
      </div>

      {/* Chat List */}
      <div className="divide-y">
        {chats.map((chat) => (
          <div key={chat.id} className="flex items-center p-4 hover:bg-gray-50 active:bg-gray-100">
            <img
              src={chat.avatar}
              alt={chat.name}
              className="w-12 h-12 rounded-full"
            />
            <div className="flex-1 min-w-0 ml-4">
              <div className="flex items-center justify-between">
                <h3 className="text-sm font-medium truncate">{chat.name}</h3>
                <span className="text-xs text-gray-500 flex-shrink-0">{chat.time}</span>
              </div>
              <p className="text-sm text-gray-500 truncate">{chat.message}</p>
            </div>
            {chat.unread && (
              <span className="ml-2 w-5 h-5 bg-orange-500 rounded-full flex items-center justify-center text-white text-xs flex-shrink-0">
                {chat.unread}
              </span>
            )}
          </div>
        ))}
      </div>

      {/* New Chat Button */}
      <button
        onClick={() => setIsNewChatOpen(true)}
        className="fixed bottom-20 left-1/2 transform -translate-x-1/2 bg-black text-white px-6 py-3 rounded-full flex items-center gap-2 shadow-lg hover:bg-gray-900 active:bg-gray-800 transition-colors"
      >
        <Plus className="w-5 h-5" />
        <span>New Chat</span>
      </button>

      {/* New Chat Popup */}
      {isNewChatOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-end justify-center z-50">
          <div className="bg-white rounded-t-3xl w-full max-w-md p-4 space-y-4 animate-slide-up">
            <div className="space-y-4">
              <button 
                className="flex items-center w-full p-3 hover:bg-gray-50 active:bg-gray-100 rounded-xl transition-colors"
                onClick={() => setIsNewChatOpen(false)}
              >
                <MessageSquare className="w-6 h-6 text-gray-600" />
                <div className="ml-3 text-left">
                  <div className="font-medium">New Chat</div>
                  <div className="text-sm text-gray-500">Send a message to your contact</div>
                </div>
              </button>

              <button 
                className="flex items-center w-full p-3 hover:bg-gray-50 active:bg-gray-100 rounded-xl transition-colors"
                onClick={() => setIsNewChatOpen(false)}
              >
                <UserPlus className="w-6 h-6 text-gray-600" />
                <div className="ml-3 text-left">
                  <div className="font-medium">New Contact</div>
                  <div className="text-sm text-gray-500">Add a contact to be able to send messages</div>
                </div>
              </button>

              <button 
                className="flex items-center w-full p-3 hover:bg-gray-50 active:bg-gray-100 rounded-xl transition-colors"
                onClick={() => setIsNewChatOpen(false)}
              >
                <Users className="w-6 h-6 text-gray-600" />
                <div className="ml-3 text-left">
                  <div className="font-medium">New Community</div>
                  <div className="text-sm text-gray-500">Join the community around you</div>
                </div>
              </button>
            </div>

            <button
              onClick={() => setIsNewChatOpen(false)}
              className="w-full py-3 text-gray-600 font-medium rounded-xl hover:bg-gray-50 active:bg-gray-100 transition-colors"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Inbox;
